import { takeLatest } from 'typed-redux-saga';
import { workerErrorNotifyThunk } from 'utils/sagas';
import { actionReportYieldLinkedMarketFetch } from './actions';

export const sagasReportYieldLinkedMarket = [
  takeLatest(actionReportYieldLinkedMarketFetch.rejected, workerErrorNotifyThunk),
];
